import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button
} from 'semantic-ui-react'

const CardPayrollTabUX = (props: any) => {
    return(
      <div
        id="CardPayrollTabUX-div-0"
        style={{ maxHeight: '100vh', overflowY: 'auto', padding: '20px' }}>
        <Button
          color={props.handleSalaryTabcolor}
          id="CardPayrollTabUX-Button-1"
          onClick={props.handleChangeSalaryTab}
          style={{display: props.filteredTabMenu?.includes("SALARY")?"":"none"}}>
          {props.languageUX === "en" ? "Salary" : "เงินเดือน"}
        </Button>
        <Button
          color={props.handleRevenueTabcolor}
          id="CardPayrollTabUX-Button-2"
          onClick={props.handleChangeRevenueTab}
          style={{display: props.filteredTabMenu?.includes("REVENUEANDDEDUCT")?"":"none"}}>
          {props.languageUX === "en" ? "Revenue & Deduct" : "รายได้และหักลดหย่อน"}
        </Button>
        <Button
          color={props.handleSettingTabcolor}
          id="CardPayrollTabUX-Button-3"
          onClick={props.handleChangeSettingTab}
          style={{display: props.filteredTabMenu?.includes("SETTING")?"":"none"}}>
          {props.languageUX === "en" ? "Setting" : "การตั้งค่า"}
        </Button>
        <div
          id="CardPayrollTabUX-div-4">
          {props.displayTab}
        </div>
      </div>
    )
}


export default CardPayrollTabUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayrollTabUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ maxHeight: '100vh', overflowY: 'auto', padding: '20px' }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Button",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "เงินเดือน",
          "valueEN": "Salary"
        },
        "color": {
          "type": "code",
          "value": "props.handleSalaryTabcolor"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollTabUX-Button-1"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleChangeSalaryTab"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"SALARY\")?\"\":\"none\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Button",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "รายได้และหักลดหย่อน",
          "valueEN": "Revenue & Deduct"
        },
        "color": {
          "type": "code",
          "value": "props.handleRevenueTabcolor"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollTabUX-Button-2"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleChangeRevenueTab"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"REVENUEANDDEDUCT\")?\"\":\"none\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Button",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "การตั้งค่า",
          "valueEN": "Setting"
        },
        "color": {
          "type": "code",
          "value": "props.handleSettingTabcolor"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollTabUX-Button-3"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleChangeSettingTab"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"SETTING\")?\"\":\"none\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.displayTab"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollTabUX-div-4"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 4,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardPayrollTabUX",
  "project": "New Project",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
